import * as yup from 'yup';

export const trackingTypeSchema = yup.object().shape({
  name: yup.string().required(),
  trackingDataType: yup.string().required(),
  description: yup.string().required(),
});
